import { Link } from '@tanstack/react-router';
import { Compass } from 'lucide-react';
import { Card } from '@/components/ui/Card';
import { EmptyState } from '@/components/ui/Feedback';

export function NotFoundPage(): React.JSX.Element {
  return (
    <Card>
      <h1 className="sr-only">Page not found</h1>
      <EmptyState
        icon={<Compass className="size-5" aria-hidden="true" />}
        title="That page does not exist"
        description="The address may be from an older version of the console, or the record it pointed at was removed."
        action={
          <Link
            to="/"
            className="rounded-[var(--radius-control)] bg-accent px-3.5 py-2 text-sm font-medium text-accent-fg"
          >
            Back to the dashboard
          </Link>
        }
      />
    </Card>
  );
}
